var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteAudienceProIconTail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 180,
    viewBox: "0 0 100 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 130,
    r: 50,
    fill: "#142533"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4488 101C54.4463 101 58.4974 105.051 58.4974 110.049C58.4974 115.046 54.4463 119.097 49.4488 119.097C44.4514 119.097 40.4001 115.046 40.4001 110.049C40.4001 105.051 44.4514 101 49.4488 101ZM49.4488 105.062C46.695 105.062 44.4626 107.295 44.4626 110.049C44.4626 112.802 46.695 115.035 49.4488 115.035C52.2026 115.035 54.4349 112.802 54.4349 110.049C54.4349 107.295 52.2026 105.062 49.4488 105.062Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1262 135.575C21.1262 136.697 20.2168 137.607 19.095 137.607C17.9732 137.607 17.0637 136.697 17.0637 135.575V125.477C17.0637 123.393 18.632 121.676 20.6525 121.442L21.1262 121.414L32.3275 121.412C31.7506 122.408 31.3794 123.538 31.2716 124.744L31.2391 125.477H21.1262V135.575Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9281 137.607C81.0497 137.607 81.9593 136.697 81.9593 135.575V125.477L81.9317 125.003C81.6973 122.983 79.9801 121.414 77.8968 121.414L66.5852 121.412C67.182 122.443 67.559 123.617 67.6512 124.87L67.6736 125.477H77.8968V135.575C77.8968 136.697 78.806 137.607 79.9281 137.607Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5483 121.414C61.6316 121.414 63.3488 122.983 63.5836 125.003L63.6108 125.477V135.575C63.6108 136.697 62.7012 137.607 61.5796 137.607C60.4579 137.607 59.5483 136.697 59.5483 135.575V125.477H39.3635V135.575C39.3635 136.697 38.4541 137.607 37.3323 137.607C36.2105 137.607 35.301 136.697 35.301 135.575V125.477C35.301 123.393 36.8693 121.676 38.8898 121.442L39.3635 121.414H59.5483Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4821 111.325C77.4821 107.032 74.0021 103.552 69.7093 103.552C65.4165 103.552 61.9365 107.032 61.9365 111.325C61.9365 115.617 65.4165 119.097 69.7093 119.097C74.0021 119.097 77.4821 115.617 77.4821 111.325ZM65.999 111.325C65.999 109.275 67.6602 107.614 69.7093 107.614C71.7584 107.614 73.4196 109.275 73.4196 111.325C73.4196 113.374 71.7584 115.035 69.7093 115.035C67.6602 115.035 65.999 113.374 65.999 111.325Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2517 103.552C33.5445 103.552 37.0245 107.032 37.0245 111.325C37.0245 115.617 33.5445 119.097 29.2517 119.097C24.959 119.097 21.479 115.617 21.479 111.325C21.479 107.032 24.959 103.552 29.2517 103.552ZM29.2517 107.614C27.2026 107.614 25.5415 109.275 25.5415 111.325C25.5415 113.374 27.2026 115.035 29.2517 115.035C31.3009 115.035 32.962 113.374 32.962 111.325C32.962 109.275 31.3009 107.614 29.2517 107.614Z",
    fill: "#F2F2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 141.669C17.9094 141.669 17 142.579 17 143.7V147.763C17 153.372 21.5471 157.919 27.1562 157.919H71.8438C77.4528 157.919 82 153.372 82 147.763V143.7C82 142.579 81.0904 141.669 79.9688 141.669H19.0312ZM21.0625 147.763V145.732H77.9375V147.763C77.9375 151.128 75.2091 153.857 71.8438 153.857H27.1562C23.7908 153.857 21.0625 151.128 21.0625 147.763Z",
    fill: "#F2F2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 75H50.5V80H48.5V75Z",
    fill: "#142533"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 67H50.5V72H48.5V67Z",
    fill: "#142533"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 60H50.5V65H48.5V60Z",
    fill: "#142533"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 53H50.5V58H48.5V53Z",
    fill: "#142533"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 45H50.5V50H48.5V45Z",
    fill: "#142533"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 37H50.5V42H48.5V37Z",
    fill: "#142533"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 30H50.5V35H48.5V30Z",
    fill: "#142533"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 23H50.5V28H48.5V23Z",
    fill: "#142533"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 15H50.5V20H48.5V15Z",
    fill: "#142533"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 8H50.5V13H48.5V8Z",
    fill: "#142533"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 0H50.5V5H48.5V0Z",
    fill: "#142533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteAudienceProIconTail);
export default __webpack_public_path__ + "static/media/CompleteAudienceProIconTail.9478cd0d0f2aaac1b2535c9511027abc.svg";
export { ForwardRef as ReactComponent };